module.exports = __webpack_public_path__ + "img/publish_active.8519992c.png";